export default __webpack_public_path__ + "static/media/opera.0b8dcb80.svg";